function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EdgeIntersection from './EdgeIntersection';
import Coordinate from '../geom/Coordinate';
import Label from './Label';
import Edge from './Edge';
import TreeMap from '../../../../java/util/TreeMap';
var EdgeIntersectionList = /*#__PURE__*/function () {
  function EdgeIntersectionList() {
    _classCallCheck(this, EdgeIntersectionList);
    EdgeIntersectionList.constructor_.apply(this, arguments);
  }
  return _createClass(EdgeIntersectionList, [{
    key: "print",
    value: function print(out) {
      out.println('Intersections:');
      for (var it = this.iterator(); it.hasNext();) {
        var ei = it.next();
        ei.print(out);
      }
    }
  }, {
    key: "iterator",
    value: function iterator() {
      return this._nodeMap.values().iterator();
    }
  }, {
    key: "addSplitEdges",
    value: function addSplitEdges(edgeList) {
      this.addEndpoints();
      var it = this.iterator();
      var eiPrev = it.next();
      while (it.hasNext()) {
        var ei = it.next();
        var newEdge = this.createSplitEdge(eiPrev, ei);
        edgeList.add(newEdge);
        eiPrev = ei;
      }
    }
  }, {
    key: "addEndpoints",
    value: function addEndpoints() {
      var maxSegIndex = this.edge.pts.length - 1;
      this.add(this.edge.pts[0], 0, 0.0);
      this.add(this.edge.pts[maxSegIndex], maxSegIndex, 0.0);
    }
  }, {
    key: "createSplitEdge",
    value: function createSplitEdge(ei0, ei1) {
      var npts = ei1.segmentIndex - ei0.segmentIndex + 2;
      var lastSegStartPt = this.edge.pts[ei1.segmentIndex];
      var useIntPt1 = ei1.dist > 0.0 || !ei1.coord.equals2D(lastSegStartPt);
      if (!useIntPt1) {
        npts--;
      }
      var pts = new Array(npts).fill(null);
      var ipt = 0;
      pts[ipt++] = new Coordinate(ei0.coord);
      for (var i = ei0.segmentIndex + 1; i <= ei1.segmentIndex; i++) {
        pts[ipt++] = this.edge.pts[i];
      }
      if (useIntPt1) pts[ipt] = ei1.coord;
      return new Edge(pts, new Label(this.edge._label));
    }
  }, {
    key: "add",
    value: function add(intPt, segmentIndex, dist) {
      var eiNew = new EdgeIntersection(intPt, segmentIndex, dist);
      var ei = this._nodeMap.get(eiNew);
      if (ei !== null) {
        return ei;
      }
      this._nodeMap.put(eiNew, eiNew);
      return eiNew;
    }
  }, {
    key: "isIntersection",
    value: function isIntersection(pt) {
      for (var it = this.iterator(); it.hasNext();) {
        var ei = it.next();
        if (ei.coord.equals(pt)) return true;
      }
      return false;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeIntersectionList;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { EdgeIntersectionList as default };
EdgeIntersectionList.constructor_ = function () {
  this._nodeMap = new TreeMap();
  this.edge = null;
  var edge = arguments[0];
  this.edge = edge;
};